// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"167a55b2","488":"8f8cf279"}[chunkId] + ".chunk.js";
};